export interface IUser {
  id: number;
  userName: string;
  role: string;
  profiles: string;
  createdAt: string;
  updatedAt: string;
  keycloakId?: string,
  servolabId?: string,
  password?: string;
}

export interface ICreateUpdateUserRequest {
  id: number;
  userName: string;
  role: string;
  profiles: string;
  password?: string;
  confirmPassword?: string;
}

export interface KeycloakUser {
  id: string;
  createdTimestamp: number;
  username: string;
  enabled: boolean;
  totp: boolean;
  emailVerified: boolean;
  firstName: string;
  lastName: string;
  email: string;
  attributes: {
    locale: string[];
  };
  disableableCredentialTypes: string[];
  requiredActions: string[];
  notBefore: number;
  access: {
    manageGroupMembership: boolean;
    view: boolean;
    mapRoles: boolean;
    impersonate: boolean;
    manage: boolean;
  };
}

export interface KeycloakUserCreateDTO {
  username: string;
  firstName: string;
  lastName: string;
  email: string;
  password?: string;
}
